var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "autocompletion-location" }, [
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.autocompletionResultsIsOpen &&
              _vm.autocompletionResults.length != 0,
            expression:
              "autocompletionResultsIsOpen && autocompletionResults.length != 0"
          }
        ]
      },
      _vm._l(_vm.autocompletionResults, function(result, i) {
        return _c(
          "li",
          {
            key: i,
            on: {
              click: function($event) {
                return _vm.setLocationResult(result)
              }
            }
          },
          [
            _vm._v(
              _vm._s(result.properties.city) +
                " (" +
                _vm._s(result.properties.postcode) +
                ")\n        "
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }